import React, { useState, useEffect, useRef } from 'react';
import Dashboard from './Dashboard';
import axios from 'axios';
import io from 'socket.io-client';
import './App.css';
import './FastFood.css';

function GarmentsPage() {
  const [products, setProducts] = useState([]);
  const [name, setName] = useState('');
  const [cost_of_product, setCostOfProduct] = useState('');
  const [margin_of_product, setMarginOfProduct] = useState('');
  const [price_show_to_customer, setPriceShowToCustomer] = useState('');
  const [image, setImage] = useState([]); // Stores { file, quantity, url, isNew } objects
  const [category, setCategory] = useState('');
  const [size, setSize] = useState('');
  const [editId, setEditId] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [orderType, setOrderType] = useState('individual');
  const [minPurchasingPrice, setMinPurchasingPrice] = useState('');
  const [maxPurchasingPrice, setMaxPurchasingPrice] = useState('');
  const [groupSize, setGroupSize] = useState('');
  const [familySize, setFamilySize] = useState('');
  const [offerItems, setOfferItems] = useState([{ product: '', value: '' }]);
  const [offers, setOffers] = useState([]);
  const [filterType, setFilterType] = useState('all');
  const [editOfferId, setEditOfferId] = useState(null);
  const [isListening, setIsListening] = useState(false);
  const [showTrendingOnly, setShowTrendingOnly] = useState(false);
  const [isTrending, setIsTrending] = useState(false);
  const fileInputRef = useRef(null);
  const [parentImageIndex, setParentImageIndex] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [childImages, setChildImages] = useState([]);
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = SpeechRecognition ? new SpeechRecognition() : null;
  const socket = useRef(null);

  const apiUrl = process.env.REACT_APP_API_URL || 'https://vakra.co.in/api';
  const socketUrl = process.env.REACT_APP_WEBSOCKET_URL || 'https://vakra.co.in';

  useEffect(() => {
    if (token) {
      fetchProducts();
      fetchOffers();
      socket.current = io(socketUrl, {
        query: { token },
        path: '/socket.io',
      });
      socket.current.on('stockUpdated', (data) => {
        console.log('Stock updated received:', data);
        fetchProducts(); // Refresh products on stock update
      });
      socket.current.on('orderUpdated', (updatedProduct) => {
        setProducts((prevProducts) =>
          prevProducts.map((p) =>
            p.id === updatedProduct.id ? { ...p, image_quantities: updatedProduct.image_quantities } : p
          )
        );
      });

      return () => {
        if (socket.current) socket.current.disconnect();
      };
    }

    if (recognition) {
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = 'en-US';

      recognition.onstart = () => {
        console.log('Speech recognition started');
        setIsListening(true);
      };

      recognition.onresult = (event) => {
        if (event.results && event.results[0] && event.results[0][0]) {
          const transcript = event.results[0][0].transcript;
          console.log('Recognized text:', transcript);
          setName(transcript);
        } else {
          console.error('No speech recognition result found');
          alert('No speech recognized. Please try again.');
        }
        setIsListening(false);
      };

      recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
        alert('Speech recognition error: ' + event.error);
        setIsListening(false);
      };

      recognition.onend = () => {
        console.log('Speech recognition ended');
        setIsListening(false);
      };

      recognition.onspeechstart = () => console.log('Speech detected');
      recognition.onspeechend = () => console.log('Speech ended');
    } else {
      console.log('Speech Recognition not supported in this browser');
    }

    return () => {
      if (recognition) recognition.stop();
    };
  }, [token]);

  const startVoiceRecognition = () => {
    if (!recognition) {
      alert('Speech Recognition is not supported in this browser!');
      return;
    }

    if (isListening) {
      console.log('Stopping speech recognition');
      recognition.stop();
    } else {
      console.log('Starting speech recognition');
      try {
        recognition.start();
      } catch (error) {
        console.error('Error starting speech recognition:', error);
        alert('Error starting speech recognition: ' + error.message);
        setIsListening(false);
      }
    }
  };

  const fetchProducts = () => {
    console.log('Fetching products with token:', token);
    axios
      .get(`${apiUrl}/products?grdb=true`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        console.log('Products fetched successfully:', res.data);
        if (Array.isArray(res.data)) {
          const updatedProducts = res.data.map(product => ({
            ...product,
            image: Array.isArray(product.image) ? product.image : typeof product.image === 'string' ? JSON.parse(product.image || '[]') : [],
            image_quantities: Array.isArray(product.image_quantities) ? product.image_quantities : typeof product.image_quantities === 'string' ? JSON.parse(product.image_quantities || '[]') : []
          }));
          setProducts(updatedProducts);
        } else {
          console.error('Unexpected response format:', res.data);
          setProducts([]);
        }
      })
      .catch(err => {
        console.error('Fetch Products Error:', err.response ? err.response.data : err.message);
        alert('Failed to fetch products: ' + (err.response?.data?.error || err.message));
        setProducts([]);
      });
  };

  const fetchOffers = () => {
    console.log('Fetching offers with token:', token);
    axios
      .get(`${apiUrl}/offers?grdb=true`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        console.log('Fetched Offers Response:', res.data);
        const offersWithId = res.data.map(offer => ({
          ...offer,
          id: offer.id || null
        }));
        setOffers(offersWithId);
      })
      .catch(err => {
        console.error('Fetch Offers Error:', err.response ? err.response.data : err.message);
        alert('Failed to fetch offers: ' + (err.response?.data?.error || err.message));
      });
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files).map(file => ({ file, quantity: 1, url: URL.createObjectURL(file), isNew: true }));
    if (files.length > 0) setImage(prev => [...prev, ...files]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files)
      .filter(file => file.type.startsWith('image/'))
      .map(file => ({ file, quantity: 1, url: URL.createObjectURL(file), isNew: true }));
    if (files.length > 0) setImage(prev => [...prev, ...files]);
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleRemoveImage = (indexToRemove) => {
    setImage(prev => {
      const updated = prev.filter((_, index) => index !== indexToRemove);
      if (updated.length === 0) {
        setParentImageIndex(-1); // No images left, reset parent index
      } else if (indexToRemove === parentImageIndex) {
        setParentImageIndex(0); // Reset to first image if current parent is removed
      } else if (indexToRemove < parentImageIndex) {
        setParentImageIndex(prev => Math.max(0, prev - 1)); // Adjust index if removed before current parent
      }

      // Sync with backend to remove image
      if (editId) {
        const product = products.find(p => p.id === editId);
        if (product) {
          const originalIndex = product.image.findIndex(img => img === prev[indexToRemove].url || (prev[indexToRemove].isNew && !prev[indexToRemove].file));
          if (originalIndex !== -1) {
            axios.put(`${apiUrl}/products/${editId}?grdb=true`, {
              remove_image_indices: [originalIndex],
            }, {
              headers: { Authorization: `Bearer ${token}` },
            }).then(() => {
              fetchProducts(); // Refresh to update dropdown
            }).catch(err => {
              alert(`Failed to remove image: ${err.message}`);
            });
          }
        }
      }

      console.log('Updated image state after removal:', updated);
      return updated;
    });
  };

  const handleQuantityChange = (index, value) => {
    const newQuantity = Math.max(1, parseInt(value) || 1);
    setImage(prev => {
      const newImages = [...prev];
      newImages[index] = { ...newImages[index], quantity: newQuantity };
      return newImages;
    });
  };

  const handleAddProduct = async (e) => {
    e.preventDefault();
    if (!name || !cost_of_product || !margin_of_product || !category) {
      alert('Name, cost_of_product, margin_of_product, and category are required fields!');
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('cost_of_product', cost_of_product);
    formData.append('margin_of_product', margin_of_product);
    formData.append('price_show_to_customer', price_show_to_customer || '0.00');
    formData.append('category', category);
    formData.append('size', size || '');
    formData.append('trend_item', isTrending ? '1' : '0');
    if (image.length > 0 && parentImageIndex >= 0 && parentImageIndex < image.length) {
      formData.append('parent_image_index', parentImageIndex);
    } else {
      formData.append('parent_image_index', -1);
    }

    const existingProduct = editId ? products.find(p => p.id === editId) : null;
    const removeImageIndices = [];
    let imageIndex = 0;

    if (editId && existingProduct) {
      const existingImagePaths = existingProduct.image.map(url => url.replace(apiUrl, ''));
      console.log('Existing Image Paths:', existingImagePaths);

      existingImagePaths.forEach((path, idx) => {
        const isRemoved = !image.some(imgObj =>
          imgObj.url && imgObj.url.includes(path) && (!imgObj.isNew || imgObj.file)
        );
        if (isRemoved) {
          removeImageIndices.push(idx);
        }
      });
      console.log('Calculated Remove Image Indices:', removeImageIndices);

      const updatedImageState = image.filter(imgObj =>
        imgObj.isNew || (imgObj.file || existingImagePaths.includes(imgObj.url.replace(apiUrl, '')))
      );
      console.log('Updated Image State:', updatedImageState);
      if (parentImageIndex >= updatedImageState.length || !updatedImageState[parentImageIndex]) {
        setParentImageIndex(updatedImageState.length > 0 ? 0 : -1);
      }
      setImage(updatedImageState);

      image.forEach((imgObj, idx) => {
        if (imgObj.file) {
          formData.append('image', imgObj.file);
        }
        formData.append(`image_quantities[${imageIndex}]`, imgObj.quantity || 1);
        imageIndex++;
      });
      if (removeImageIndices.length > 0 || (existingImagePaths.length > 0 && updatedImageState.length === 0)) {
        formData.append('remove_image_indices', JSON.stringify(removeImageIndices.length > 0 ? removeImageIndices : existingImagePaths.map((_, idx) => idx)));
      }
    } else {
      image.forEach((imgObj, idx) => {
        if (imgObj.file) {
          formData.append('image', imgObj.file);
        }
        formData.append(`image_quantities[${idx}]`, imgObj.quantity || 1);
      });
    }

    console.log('Sending FormData:', {
      name, cost_of_product, margin_of_product, price_show_to_customer, category, size,
      trend_item: isTrending ? '1' : '0', parentImageIndex, imageQuantities: image.map(img => img.quantity),
      removeImageIndices, editId
    });
    for (let [key, value] of formData.entries()) console.log(`${key}: ${value}`);

    const config = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } };
    const request = editId
      ? axios.put(`${apiUrl}/products/${editId}?grdb=true`, formData, config)
      : axios.post(`${apiUrl}/products?grdb=true`, formData, config);

    try {
      const res = await request;
      console.log('Response:', res.data);
      if (res.data && res.data.error) {
        throw new Error(res.data.error);
      }
      const newProduct = res.data;
      setProducts(prevProducts => editId ? prevProducts.map(p => p.id === editId ? newProduct : p) : [...prevProducts, newProduct]);
      setEditId(null);
      setName('');
      setCostOfProduct('');
      setMarginOfProduct('');
      setPriceShowToCustomer('');
      setCategory('');
      setSize('');
      setImage([]);
      setParentImageIndex(0);
      setIsTrending(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
      fetchProducts();
    } catch (err) {
      const errorMsg = err.response ? err.response.data.error || err.response.statusText : err.message;
      console.error('Add/Update Product Error:', err);
      alert(`Failed to ${editId ? 'update' : 'add'} product: ${errorMsg}`);
    }
  };

  const handleRemoveProduct = (id) => {
    if (!window.confirm('Are you sure you want to delete this product?')) return;
    axios
      .delete(`${apiUrl}/products/${id}?grdb=true`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        setProducts(prevProducts => prevProducts.filter(p => p.id !== id));
        fetchProducts();
      })
      .catch(err => {
        const errorMsg = err.response ? err.response.data.error || err.response.statusText : err.message;
        console.error('Remove Product Error:', err);
        alert('Failed to delete product: ' + errorMsg);
      });
  };

  const handleEditProduct = (id) => {
    const product = products.find(p => p.id === id);
    if (!product) return alert('Product not found');
    setName(product.name);
    setCostOfProduct(product.cost_of_product?.toString() || '');
    setMarginOfProduct(product.margin_of_product?.toString() || '');
    setPriceShowToCustomer(product.price_show_to_customer?.toString() || '');
    setCategory(product.category || '');
    setSize(product.size || '');
    setImage(product.image.map((imgUrl, index) => ({
      url: imgUrl,
      quantity: product.image_quantities[index] !== undefined ? product.image_quantities[index] : 1,
      isNew: false
    })));
    setParentImageIndex(product.parent_image_index !== undefined && product.image[product.parent_image_index] ? product.parent_image_index : 0);
    setIsTrending(product.trend_item === 1);
    setEditId(id);
  };

  const handleChangeParentImage = (id, newParentIndex) => {
    const product = products.find(p => p.id === id);
    if (!product) return alert('Product not found');
    const formData = new FormData();
    formData.append('parent_image_index', newParentIndex);
    formData.append('image_quantities', JSON.stringify(product.image_quantities));

    console.log('Sending FormData for parent image change:', { id, newParentIndex, image_quantities: product.image_quantities });
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    axios
      .put(`${apiUrl}/products/${id}?grdb=true`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      })
      .then(res => {
        const updatedProduct = res.data;
        setProducts(prevProducts => prevProducts.map(p => p.id === id ? updatedProduct : p));
        fetchProducts();
      })
      .catch(err => {
        const errorMsg = err.response ? err.response.data.error || err.response.statusText : err.message;
        console.error('Change Parent Image Error:', err);
        alert(`Failed to change parent image: ${errorMsg}`);
      });
  };

  const handleOfferItemChange = (index, field, value) => {
    const newOfferItems = [...offerItems];
    newOfferItems[index][field] = value;
    setOfferItems(newOfferItems);
  };

  const addOfferItem = () => setOfferItems([...offerItems, { product: '', value: '' }]);

  const removeOfferItem = (index) => setOfferItems(offerItems.filter((_, i) => i !== index));

  const calculateOffer = () => {
    const validOfferItems = offerItems.filter(item => item.product.trim() && !isNaN(parseFloat(item.value)) && parseFloat(item.value) >= 0);
    return validOfferItems.length === 0 ? 'No Offer' : validOfferItems.map(item => `${parseFloat(item.value).toFixed(2) || 0}₹ ${item.product.trim()}`).join(', ');
  };

  const formatOfferForDisplay = (offerText) => offerText.split(', ').map(item => item).join(', ');

  const handleAddOffer = (e) => {
    e.preventDefault();
    const minPrice = parseFloat(minPurchasingPrice);
    const maxPrice = parseFloat(maxPurchasingPrice);
    const offerText = calculateOffer();

    if (isNaN(minPrice) || isNaN(maxPrice) || minPrice >= maxPrice || minPrice < 0 || maxPrice < 0 || offerText === 'No Offer') {
      alert('Please provide a valid price range and at least one offer item with valid product and value!');
      return;
    }

    const config = { headers: { Authorization: `Bearer ${token}` } };
    const newOffer = {
      order_type: orderType,
      min_purchasing_price: minPrice,
      max_purchasing_price: maxPrice,
      group_size: orderType === 'group' ? parseInt(groupSize) || null : null,
      family_size: orderType === 'family' ? parseInt(familySize) || null : null,
      offer_text: offerText,
    };

    const url = editOfferId
      ? `${apiUrl}/offers/${editOfferId}?grdb=true`
      : `${apiUrl}/offers?grdb=true`;
    const method = editOfferId ? axios.put : axios.post;

    method(url, newOffer, config)
      .then(res => {
        setOffers(prevOffers => editOfferId ? prevOffers.map(o => o.id === editOfferId ? res.data : o) : [...prevOffers, res.data]);
        resetOfferForm();
        fetchOffers();
      })
      .catch(err => {
        const errorMsg = err.response ? err.response.data.error || err.response.statusText : err.message;
        console.error('Add/Update Offer Error:', err);
        alert(`Failed to ${editOfferId ? 'update' : 'add'} offer: ${errorMsg}`);
      });
  };

  const handleDeleteOffer = (id) => {
    if (!window.confirm('Are you sure you want to delete this offer?')) return;
    if (!id || isNaN(parseInt(id))) {
      alert('Invalid offer ID');
      return;
    }
    axios
      .delete(`${apiUrl}/offers/${id}?grdb=true`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        setOffers(prevOffers => prevOffers.filter(o => o.id !== id));
        fetchOffers();
      })
      .catch(err => {
        const errorMsg = err.response ? err.response.data.error || err.response.statusText : err.message;
        console.error('Delete Offer Error:', err);
        alert('Failed to delete offer: ' + errorMsg);
      });
  };

  const handleEditOffer = (id) => {
    const offer = offers.find(o => o.id === id);
    if (!offer || !offer.id) {
      alert('Offer not found or invalid ID');
      return;
    }
    setOrderType(offer.order_type);
    setMinPurchasingPrice(offer.min_purchasing_price || '');
    setMaxPurchasingPrice(offer.max_purchasing_price || '');
    setGroupSize(offer.group_size || '');
    setFamilySize(offer.family_size || '');
    setOfferItems(
      offer.offer_text.split(', ').map(text => {
        const [value, product] = text.split('₹ ');
        return { value: value.trim(), product: product || '' };
      }).filter(item => item.value && item.product)
    );
    setEditOfferId(offer.id);
  };

  const resetOfferForm = () => {
    setOrderType('individual');
    setMinPurchasingPrice('');
    setMaxPurchasingPrice('');
    setGroupSize('');
    setFamilySize('');
    setOfferItems([{ product: '', value: '' }]);
    setEditOfferId(null);
  };

  const filteredOffers = filterType === 'all' ? offers : offers.filter(o => o.order_type === filterType);

  const handleLogin = (e) => {
    e.preventDefault();
    axios
      .post(`${apiUrl}/auth/login`, { email: prompt('Enter email'), password: prompt('Enter password') })
      .then(res => {
        setToken(res.data.token);
        localStorage.setItem('token', res.data.token);
      })
      .catch(err => alert(err.response?.data?.error || 'Network Error: Please try again'));
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    const childImages = product.image.map((img, index) => ({
      url: img,
      index,
      quantity: product.image_quantities[index] !== undefined ? Math.max(0, product.image_quantities[index]) : 0
    }));
    setChildImages(childImages);
  };

  const handleClosePopup = () => {
    setSelectedProduct(null);
    setChildImages([]);
  };

  const calculateTotalQuantity = (product) => {
    return product.image_quantities ? product.image_quantities.reduce((sum, qty) => sum + (parseInt(qty) || 0), 0) : product.image.length || 0;
  };

  if (!token) return (
    <div className="login-prompt">
      <h2>Please Login</h2>
      <button onClick={handleLogin}>Login</button>
    </div>
  );

  const displayedProducts = showTrendingOnly
    ? products.filter(p => p.trend_item === 1)
    : products;

  return (
              <div 
            className="fast-food-wrapper" 
            style={{ 
              marginTop: '60px',
              minHeight: '100vh',
              overflow: 'hidden',        /* ← ये लाइन स्क्रॉल बंद कर देगी */
              paddingBottom: '120px'     /* ← नीचे थोड़ा स्पेस रहेगा */
            }}
              >
      <Dashboard />
      <div className="fast-food-container">
        <h1 className="page-title">Garments Products Menu</h1>

        <form onSubmit={handleAddProduct} className="product-form">
          <div className="input-with-voice">
            <input
              type="text"
              placeholder="Product Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input-field"
            />
            <button
              type="button"
              onClick={startVoiceRecognition}
              className={`voice-btn ${isListening ? 'listening' : ''}`}
            >
              <span className="voice-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 1v10"></path>
                  <path d="M17 5a5 5 0 0 1-10 0"></path>
                  <path d="M12 23v-2"></path>
                  <path d="M19 11v2a7 7 0 0 1-14 0v-2"></path>
                </svg>
              </span>
            </button>
          </div>
          <input
            type="number"
            placeholder="Cost of Product (in ₹)"
            value={cost_of_product}
            onChange={(e) => setCostOfProduct(e.target.value)}
            className="input-field"
          />
          <input
            type="number"
            placeholder="Margin of Product (in ₹)"
            value={margin_of_product}
            onChange={(e) => setMarginOfProduct(e.target.value)}
            className="input-field"
          />
          <input
            type="number"
            placeholder="Price Show to Customer (in ₹)"
            value={price_show_to_customer}
            onChange={(e) => setPriceShowToCustomer(e.target.value)}
            className="input-field"
          />
          <input
            type="text"
            placeholder="Add Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="input-field"
          />
          <input
            type="text"
            placeholder="Size (e.g., S, M, L) - Optional"
            value={size}
            onChange={(e) => setSize(e.target.value)}
            className="input-field"
          />
          <div className="drop-zone" onDrop={handleDrop} onDragOver={handleDragOver}>
            {image.length > 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                {image.map((imgObj, index) => (
                  <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                    <img
                      src={imgObj.url || (imgObj.file ? URL.createObjectURL(imgObj.file) : '')}
                      alt={`Preview ${index + 1}`}
                      className="preview-image"
                      style={{ maxHeight: '100px', objectFit: 'cover', margin: '5px' }}
                      onError={(e) => { e.target.src = 'https://via.placeholder.com/150'; console.log('Image load failed, using fallback'); }}
                    />
                    <input
                      type="number"
                      value={imgObj.quantity}
                      onChange={(e) => handleQuantityChange(index, e.target.value)}
                      min="1"
                      style={{ width: '50px', marginLeft: '5px', marginTop: '5px' }}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveImage(index)}
                      style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        backgroundColor: 'red',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        lineHeight: '20px',
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            ) : editId ? (
              <p>No images selected. Drag & Drop images here or click to select (No Limit)</p>
            ) : (
              <p>Drag & Drop images here or click to select (No Limit)</p>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={handleFileUpload}
              className="file-input"
              ref={fileInputRef}
              multiple
            />
          </div>
          {image.length > 0 && parentImageIndex >= 0 && (
            <div>
              <label>Select Parent Image:</label>
              <select value={parentImageIndex} onChange={(e) => setParentImageIndex(parseInt(e.target.value))} className="input-field">
                {image.map((imgObj, index) => (
                  <option key={index} value={index}>
                    Image {index + 1} (Preview: {imgObj.url || (imgObj.file ? URL.createObjectURL(imgObj.file) : '')}, Qty: {imgObj.quantity})
                  </option>
                ))}
              </select>
            </div>
          )}
          <label>
            <input
              type="checkbox"
              checked={isTrending}
              onChange={(e) => setIsTrending(e.target.checked)}
            /> Is this a trending product?
          </label>
          <button type="submit" className="submit-btn">{editId ? 'Update Product' : 'Add Product'}</button>
        </form>

        <div>
          <button onClick={() => setShowTrendingOnly(!showTrendingOnly)} className="filter-btn">
            {showTrendingOnly ? 'Show All Products' : 'Show Trending Products Only'}
          </button>
        </div>

        <div 
  className="product-list"
  style={{
   display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: '28px',
            padding: '30px 15px',
            marginTop: '50px',           /* ← Add Offer से और दूर */
            background: 'transparent',
            position: 'relative',
            zIndex: 1,
            overflow: 'visible',
            height: 'auto',              /* ← ये ऐड करो */
            maxHeight: 'none'                     // ← कार्ड्स हमेशा ऊपर रहेंगे
  }}
>
  {displayedProducts.length === 0 ? (
    <p style={{ gridColumn: '1/-1', textAlign: 'center', fontSize: '1.5em', color: '#999' }}>
      कोई प्रोडक्ट नहीं है अभी!
    </p>
  ) : (
    displayedProducts.map(product => (
      <div
        key={product.id}
        style={{
          background: 'white',
          borderRadius: '20px',
          overflow: 'hidden',
          boxShadow: '0 12px 30px rgba(0,0,0,0.12)',
          border: product.trend_item === 1 ? '4px solid #ff5722' : '2px solid #e0e0e0',
          transition: 'all 0.4s ease',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          position: 'relative',
          zIndex: 2
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-10px)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
      >
        {/* Image */}
        <img
          src={product.image?.[product.parent_image_index || 0] || 'https://via.placeholder.com/300x300.png?text=No+Image'}
          alt={product.name}
          onClick={() => handleProductClick(product)}
          style={{
            width: '100%',
            height: '220px',
            objectFit: 'cover',
            cursor: 'pointer'
          }}
        />

        {/* Details - अच्छा पैडिंग */}
        <div style={{ padding: '18px 16px', textAlign: 'center', flexGrow: 1 }}>
          <h3 style={{ 
            margin: '0 0 10px', 
            fontSize: '1.2em', 
            fontWeight: 'bold',
            color: product.trend_item === 1 ? '#d32f2f' : '#222'
          }}>
            {product.name}
            {product.trend_item === 1 && <span style={{ color: '#ff5722', fontSize: '0.9em' }}> (Trending)</span>}
          </h3>

          {/* Unique ID - सुंदर ग्रीन बैज */}
          <div style={{
            background: '#e8f5e8',
            color: '#2e7d32',
            padding: '8px 20px',
            borderRadius: '30px',
            fontWeight: 'bold',
            fontSize: '1em',
            display: 'inline-block',
            margin: '12px 0',
            fontFamily: 'monospace'
          }}>
            ID: {product.id}
          </div>

          <p style={{ margin: '10px 0', fontSize: '1.05em', color: '#444' }}>
            <strong>₹{product.price_show_to_customer}</strong><br/>
            Size: <strong>{product.size || 'N/A'}</strong> | Qty: <strong>{calculateTotalQuantity(product)}</strong>
          </p>
        </div>

        {/* Buttons - एक लाइन में, अच्छे से स्पेस, पैडिंग */}
        <div style={{
          padding: '16px 14px',
          background: '#f8f9fa',
          borderTop: '1px solid #eee',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '12px',
          flexWrap: 'nowrap'
        }}>
          <button
            onClick={() => handleEditProduct(product.id)}
            style={{
              padding: '10px 22px',
              background: '#2196f3',
              color: 'white',
              border: 'none',
              borderRadius: '30px',
              fontSize: '14px',
              fontWeight: 'bold',
              minWidth: '70px'
            }}
          >
            Edit
          </button>

          <button
            onClick={() => handleRemoveProduct(product.id)}
            style={{
              padding: '10px 22px',
              background: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '30px',
              fontSize: '14px',
              fontWeight: 'bold',
              minWidth: '70px'
            }}
          >
            Remove
          </button>

          {product.image && product.image.length > 1 && (
            <select
              value={product.parent_image_index ?? 0}
              onChange={(e) => handleChangeParentImage(product.id, parseInt(e.target.value))}
              style={{
                padding: '10px 14px',
                borderRadius: '20px',
                fontSize: '13px',
                border: '1px solid #aaa',
                background: 'white',
                minWidth: '80px'
              }}
            >
              {product.image.map((_, i) => (
                <option key={i} value={i}>Img {i + 1}</option>
              ))}
            </select>
          )}
        </div>
      </div>
    ))
  )}
</div>

        <div className="offer-section">
          <h2>{editOfferId ? 'Edit Offer' : 'Add Offer'}</h2>
          <form onSubmit={handleAddOffer}>
            <select value={orderType} onChange={(e) => setOrderType(e.target.value)} className="input-field">
              <option value="individual">Individual</option>
              <option value="group">Group</option>
              <option value="family">Family</option>
            </select>
            <input
              type="number"
              placeholder="Min Purchasing Price (in ₹)"
              value={minPurchasingPrice}
              onChange={(e) => setMinPurchasingPrice(e.target.value)}
              min="0"
              step="0.01"
              className="input-field"
              required
            />
            <input
              type="number"
              placeholder="Max Purchasing Price (in ₹)"
              value={maxPurchasingPrice}
              onChange={(e) => setMaxPurchasingPrice(e.target.value)}
              min="0"
              step="0.01"
              className="input-field"
              required
            />
            {orderType === 'group' && (
              <input
                type="number"
                placeholder="Group Size"
                value={groupSize}
                onChange={(e) => setGroupSize(e.target.value)}
                min="1"
                className="input-field"
              />
            )}
            {orderType === 'family' && (
              <input
                type="number"
                placeholder="Family Size"
                value={familySize}
                onChange={(e) => setFamilySize(e.target.value)}
                min="1"
                className="input-field"
              />
            )}
            <div>
              <h3>Offer Items</h3>
              {offerItems.map((item, index) => (
                <div key={index} className="offer-item-input">
                  <input
                    type="text"
                    placeholder="Product Name (e.g., Water Bottle)"
                    value={item.product}
                    onChange={(e) => handleOfferItemChange(index, 'product', e.target.value)}
                    className="input-field"
                  />
                  <input
                    type="number"
                    placeholder="Value (in ₹)"
                    value={item.value}
                    onChange={(e) => handleOfferItemChange(index, 'value', e.target.value)}
                    min="0"
                    step="0.01"
                    className="input-field"
                  />
                  {offerItems.length > 1 && (
                    <button type="button" onClick={() => removeOfferItem(index)} className="remove-offer-btn">Remove</button>
                  )}
                </div>
              ))}
              <button type="button" onClick={addOfferItem} className="add-more-btn">Add More Offer</button>
            </div>
            <button type="submit" className="submit-btn">{editOfferId ? 'Update Offer' : 'Add Offer'}</button>
          </form>
          <p className="suggested-offer">Suggested Offer: {calculateOffer()}</p>

          <div className="offers-list">
            <h3>Added Offers</h3>
            <div className="filter-section">
              <label>Filter by Type: </label>
              <select value={filterType} onChange={(e) => setFilterType(e.target.value)} className="input-field">
                <option value="all">All</option>
                <option value="individual">Individual</option>
                <option value="group">Group</option>
                <option value="family">Family</option>
              </select>
            </div>
            {filteredOffers.length === 0 ? (
              <p>No offers match the filter!</p>
            ) : (
              <table className="offers-table">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Min Price (₹)</th>
                    <th>Max Price (₹)</th>
                    <th>Group Size</th>
                    <th>Family Size</th>
                    <th>Offer</th>
                    <th>Vendor ID</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOffers.map(offer => (
                    <tr key={offer.id}>
                      <td>{offer.order_type}</td>
                      <td>{offer.min_purchasing_price || '0.00'}</td>
                      <td>{offer.max_purchasing_price || '0.00'}</td>
                      <td>{offer.group_size || '-'}</td>
                      <td>{offer.family_size || '-'}</td>
                      <td>{formatOfferForDisplay(offer.offer_text)}</td>
                      <td>{offer.vendor_id}</td>
                      <td>
                        <button onClick={() => handleEditOffer(offer.id)} className="edit-btn">Edit</button>
                        <button onClick={() => handleDeleteOffer(offer.id)} className="remove-btn">Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {selectedProduct && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
            onClick={handleClosePopup}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '10px',
                textAlign: 'center',
                maxWidth: '90%',
                maxHeight: '90%',
                overflowY: 'auto',
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h3>{selectedProduct.name} - Child Images</h3>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                {childImages.length > 0 ? (
                  childImages.map((imgObj, idx) => (
                    <div key={idx} style={{ textAlign: 'center' }}>
                      <img
                        src={imgObj.url}
                        alt={`${selectedProduct.name} Child ${idx + 1}`}
                        style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover', margin: '10px' }}
                        onError={(e) => (e.target.src = 'https://via.placeholder.com/150')}
                      />
                      <p>Qty: {imgObj.quantity}</p>
                    </div>
                  ))
                ) : (
                  <p>No additional images available.</p>
                )}
              </div>
              <button
                onClick={handleClosePopup}
                style={{
                  marginTop: '20px',
                  padding: '10px 20px',
                  backgroundColor: '#ff4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default GarmentsPage;
